
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire62dd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire62dd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $3fc5cd6b19a671d5$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["kb9mm","index.c601e02f.js","hKHAp","achiever.79b4f01f.png","3AJcr","busy.679d00d8.png","hf0E4","curious.dc591ea3.png","dj7qk","fighter.d0888947.png","ad4YD","myJourney.33c910a1.png","iTQf8","nobullshit.f0df6a15.png","8uccy","optimiser.91561e85.png","g3ITY","overwhelmed.bc2efa8f.png","lLj6D","protector.b4c8d30b.png","6PLwS","unlock.97372a28.png","9pgH6","yourJourney.c93f7303.png","hMZEJ","funcMed.c81f335e.png","2HUir","caffeineNeverSleeps.96304e35.png","frcm8","sleepDreamReap.bc9b786d.png","fp5by","orgFood.2b6e6b0f.png","j3Pi2","fruitJuice.3eb3fd5e.png","fcx7M","meatHead.1cbe02ae.png","waXtp","smellIt.168e4e42.png","4xax9","spermiGotNerdy.4e37a58e.png","8F9VR","holdOnToYourStrength.5ed693b4.png","1hGfp","hangovers.5bed8bc2.png"]'));

var $8c6f0a4585d0f416$exports = {};
$8c6f0a4585d0f416$exports = new URL("achiever.79b4f01f.png", import.meta.url).toString();


var $486c0e0bf330bca4$exports = {};
$486c0e0bf330bca4$exports = new URL("busy.679d00d8.png", import.meta.url).toString();


var $cc4cf0fd127f7bfa$exports = {};
$cc4cf0fd127f7bfa$exports = new URL("curious.dc591ea3.png", import.meta.url).toString();


var $893cca908cd418c3$exports = {};
$893cca908cd418c3$exports = new URL("fighter.d0888947.png", import.meta.url).toString();


var $ffe1cc4b146fc751$exports = {};
$ffe1cc4b146fc751$exports = new URL("myJourney.33c910a1.png", import.meta.url).toString();


var $0410dde85fffa931$exports = {};
$0410dde85fffa931$exports = new URL("nobullshit.f0df6a15.png", import.meta.url).toString();


var $b3f82e36a8988fff$exports = {};
$b3f82e36a8988fff$exports = new URL("optimiser.91561e85.png", import.meta.url).toString();


var $952c049fa36e4340$exports = {};
$952c049fa36e4340$exports = new URL("overwhelmed.bc2efa8f.png", import.meta.url).toString();


var $95d0fc5cbc5a572d$exports = {};
$95d0fc5cbc5a572d$exports = new URL("protector.b4c8d30b.png", import.meta.url).toString();


var $6bb15827ab8e656f$exports = {};
$6bb15827ab8e656f$exports = new URL("unlock.97372a28.png", import.meta.url).toString();


var $5b2021637611e503$exports = {};
$5b2021637611e503$exports = new URL("yourJourney.c93f7303.png", import.meta.url).toString();


var $01be2037faecd4d0$exports = {};
$01be2037faecd4d0$exports = new URL("funcMed.c81f335e.png", import.meta.url).toString();


var $a3c5cb424e96b857$exports = {};
$a3c5cb424e96b857$exports = new URL("caffeineNeverSleeps.96304e35.png", import.meta.url).toString();


var $912d5e534c8c2624$exports = {};
$912d5e534c8c2624$exports = new URL("sleepDreamReap.bc9b786d.png", import.meta.url).toString();


var $6d229113cab03985$exports = {};
$6d229113cab03985$exports = new URL("orgFood.2b6e6b0f.png", import.meta.url).toString();


var $8c2c449cf3eacd7f$exports = {};
$8c2c449cf3eacd7f$exports = new URL("fruitJuice.3eb3fd5e.png", import.meta.url).toString();


const $16e45aebe61066c2$var$lore = {
    achiever: {
        title: "Welcome, Achiever.",
        par1: "You\u2019re here because you want more: more energy, sharper focus, and peak performance. You\u2019re not here to maintain - you\u2019re here to thrive. Whether refining habits or mastering mindset, let\u2019s unlock your potential with actionable insights.",
        par2: 'Go beyond the norm <a href="https://wellawarecare.substack.com/p/be-better-than-the-conventional-normal" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Be better than the conventional normal)</a> and discover your ideal vitamin D and blood glucose levels. Turn sleep into a performance asset <a href="https://wellawarecare.substack.com/p/high-performance-sleeping" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(High performance sleeping)</a>, protect your brain <a href="https://wellawarecare.substack.com/p/brain-health-101" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Brain health 101)</a>, and understand insulin resistance - from energy and inflammation to mindset <a href="https://wellawarecare.substack.com/p/care-4-invisible-insulin" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Invisible Insidious Insulin)</a>.',
        par3: "Explore sources and subscribe to the weekly newsletter.",
        par4: "Now, get after it!"
    },
    fighter: {
        title: "Hello, Fighter.",
        par1: "Life has thrown you a challenge, but you\u2019re ready to face it head-on. Whether managing a condition or overcoming health setbacks, this is your space to regain control and find strength. Discover resources that offer clarity and hope.",
        par2: 'Whatever you\u2019re fighting, you\u2019ll need energy. Learn about mitochondria - what harms them and what strengthens them <a href="https://wellawarecare.substack.com/p/your-energy-source" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Your energy source)</a>. Take a holistic approach <a href="https://wellawarecare.substack.com/p/care-11-functional-medicine-functioning" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Functional medicine functioning)</a> that sees the body as an interconnected system, not isolated parts. Explore foods that hinder your fight <a href="https://wellawarecare.substack.com/p/non-food-foods" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Non-food foods)</a>.',
        par3: "Explore sources and subscribe to the weekly newsletter.",
        par4: "Don\u2019t sweat it - you\u2019ve got loads of ammo!"
    },
    overwhelmed: {
        title: "Hi there, Overwhelmed.",
        par1: "If managing your health feels like solving a puzzle without the pieces, it is. This space makes health advice practical and manageable. Start small, build confidence, gain clarity, and dive deeper with the sources provided.",
        par2: 'Begin with \u201Cyou are what you eat\u201D and add \u201C\u2026 and the supplements you take.\u201D Explore the 80-20 of organics <a href="https://wellawarecare.substack.com/p/care-12-is-organic-food-worth-it" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Is organic food worth it?)</a>, whether supplements help or just create expensive urine <a href="https://wellawarecare.substack.com/p/supplementation-isnot-expensive-urine" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Supplementation is/not expensive urine)</a>, and the benefits of not eating <a href="https://wellawarecare.substack.com/p/less-eating-is-more-healthy" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Less (eating) is more (healthy))</a>. Understanding what goes into your body - and when - lays the foundation for navigating your health.',
        par3: "Explore sources and subscribe to the weekly newsletter.",
        par4: "It\u2019s not complicated- just interconnected!"
    },
    curious: {
        title: "Greetings, Curious.",
        par1: "You\u2019re fascinated by how health connects - sleep, nutrition, stress, and more. If uncovering the \u2018why\u2019 behind wellness and finding actionable links excites you, this space is yours.",
        par2: 'Start with functional medicine <a href="https://wellawarecare.substack.com/p/care-11-functional-medicine-functioning" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Functional medicine functioning)</a>, which treats the body as an interconnected system, factoring in biology, environment, and mind. Dive into fasting\u2019s history <a href="https://wellawarecare.substack.com/p/less-eating-is-more-healthy" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Less (eating) is more (healthy))</a> and its ties to metabolism, cognition, cellular health, and immunity. Learn how sleep <a href="https://wellawarecare.substack.com/p/high-performance-sleeping" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(High performance sleeping)</a> supports brain detox, emotional processing, and hormone balance.',
        par3: "Explore sources and subscribe to the weekly newsletter.",
        par4: "This is only the start. Welcome to the rabbit hole!"
    },
    protector: {
        title: "Welcome, Protector.",
        par1: "You value what you have and are committed to preserving it - your energy, health, and well-being. This space offers proactive strategies to safeguard your vitality now and for years to come.",
        par2: 'Understand the power of potassium, vitamin D, blood glucose, and creatine <a href="https://wellawarecare.substack.com/p/hold-on-to-your-strength" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Hold on to your strength)</a>. Learn how nutrition, supplements, and lifestyle choices help prevent Alzheimer\u2019s <a href="https://wellawarecare.substack.com/p/preventing-alzheimers-with-lifestyle" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Preventing Alzheimer\u2019s with lifestyle choices)</a>. Know that inflammation triggers health decline <a href="https://wellawarecare.substack.com/p/inflamation-to-cancer" class="nav-link lore-link" id="lore-link-mobile" target="_blank">(Inflammation to cancer)</a>, and take steps to reduce it and support your immune system.',
        par3: "Explore sources and subscribe to the weekly newsletter.",
        par4: "You\u2019re already protecting what matters - build on it!"
    }
};
var $16e45aebe61066c2$export$2e2bcd8739ae039 = $16e45aebe61066c2$var$lore;


var $dca59cc0e4d4f335$exports = {};
$dca59cc0e4d4f335$exports = new URL("meatHead.1cbe02ae.png", import.meta.url).toString();


var $9292660af542ffc5$exports = {};
$9292660af542ffc5$exports = new URL("smellIt.168e4e42.png", import.meta.url).toString();


var $d9655a7c20a8b843$exports = {};
$d9655a7c20a8b843$exports = new URL("spermiGotNerdy.4e37a58e.png", import.meta.url).toString();


var $41bb1027ed0b2ef6$exports = {};
$41bb1027ed0b2ef6$exports = new URL("holdOnToYourStrength.5ed693b4.png", import.meta.url).toString();


var $eb21f7d6540d394f$exports = {};
$eb21f7d6540d394f$exports = new URL("hangovers.5bed8bc2.png", import.meta.url).toString();


// ELEMENTS SELECTION
// Elements for sticky navigation
const $b63be9b0371e788c$var$header = document.querySelector(".header");
const $b63be9b0371e788c$var$heroBoxEl = document.querySelector(".hero-box");
// Elements for lazy loading images
// Mobile navigation menu
const $b63be9b0371e788c$var$btnNavEl = document.querySelector(".btn-mobile-nav");
const $b63be9b0371e788c$var$navContainerEl = document.querySelector(".nav-container");
const $b63be9b0371e788c$var$heroContainerEl = document.querySelector(".hero-container");
const $b63be9b0371e788c$var$sentinel = document.querySelector("#nav-sentinel");
// Elements for the persona section
const $b63be9b0371e788c$var$personaBoxElements = document.querySelectorAll(".persona-box");
const $b63be9b0371e788c$var$personaTitle = document.querySelector(".persona-title");
const $b63be9b0371e788c$var$personaText = document.querySelector(".persona-text");
const $b63be9b0371e788c$var$personeLoreTitleEl = document.querySelector(".persona-lore-title");
const $b63be9b0371e788c$var$personaLorePar1El = document.querySelector(".persona-lore-par-1");
const $b63be9b0371e788c$var$personaLorePar2El = document.querySelector(".persona-lore-par-2");
const $b63be9b0371e788c$var$personaLorePar3El = document.querySelector(".persona-lore-par-3");
const $b63be9b0371e788c$var$personaLorePar4El = document.querySelector(".persona-lore-par-4");
const $b63be9b0371e788c$var$personaImgEl = document.querySelector(".persona-img");
// Elements for the persona section mobile
const $b63be9b0371e788c$var$personaContainersMobile = document.querySelectorAll(".persona-container-mobile");
const $b63be9b0371e788c$var$personaImgMobile = document.querySelector(".persona-img-mobile");
const $b63be9b0371e788c$var$personaTextMobile = document.querySelector(".persona-text-mobile");
const $b63be9b0371e788c$var$personaTitleMobile = document.querySelector(".persona-title-mobile");
const $b63be9b0371e788c$var$loreContainerMobile = document.querySelector(".lore-container-mobile");
const $b63be9b0371e788c$var$loreTextContainerMobile = document.querySelector(".lore-text-box-mobile");
// Image obj
const $b63be9b0371e788c$var$imagesObj = {
    "imgs/achiever.png": (0, (/*@__PURE__*/$parcel$interopDefault($8c6f0a4585d0f416$exports))),
    "imgs/busy.png": (0, (/*@__PURE__*/$parcel$interopDefault($486c0e0bf330bca4$exports))),
    "imgs/curious.png": (0, (/*@__PURE__*/$parcel$interopDefault($cc4cf0fd127f7bfa$exports))),
    "imgs/fighter.png": (0, (/*@__PURE__*/$parcel$interopDefault($893cca908cd418c3$exports))),
    "imgs/myJourney.png": (0, (/*@__PURE__*/$parcel$interopDefault($ffe1cc4b146fc751$exports))),
    "imgs/nobullshit.png": (0, (/*@__PURE__*/$parcel$interopDefault($0410dde85fffa931$exports))),
    "imgs/optimiser.png": (0, (/*@__PURE__*/$parcel$interopDefault($b3f82e36a8988fff$exports))),
    "imgs/overwhelmed.png": (0, (/*@__PURE__*/$parcel$interopDefault($952c049fa36e4340$exports))),
    "imgs/protector.png": (0, (/*@__PURE__*/$parcel$interopDefault($95d0fc5cbc5a572d$exports))),
    "imgs/unlock.png": (0, (/*@__PURE__*/$parcel$interopDefault($6bb15827ab8e656f$exports))),
    "imgs/yourJourney.png": (0, (/*@__PURE__*/$parcel$interopDefault($5b2021637611e503$exports))),
    "imgs/funcMed.png": (0, (/*@__PURE__*/$parcel$interopDefault($01be2037faecd4d0$exports))),
    "imgs/caffeineNeverSleeps.png": (0, (/*@__PURE__*/$parcel$interopDefault($a3c5cb424e96b857$exports))),
    "imgs/sleepDreamReap.png": (0, (/*@__PURE__*/$parcel$interopDefault($912d5e534c8c2624$exports))),
    "imgs/orgFood.png": (0, (/*@__PURE__*/$parcel$interopDefault($6d229113cab03985$exports))),
    "imgs/fruitJuice.png": (0, (/*@__PURE__*/$parcel$interopDefault($8c2c449cf3eacd7f$exports))),
    "imgs/meatHead.png": (0, (/*@__PURE__*/$parcel$interopDefault($dca59cc0e4d4f335$exports))),
    "imgs/smellIt.png": (0, (/*@__PURE__*/$parcel$interopDefault($9292660af542ffc5$exports))),
    "imgs/spermiGotNerdy.png": (0, (/*@__PURE__*/$parcel$interopDefault($d9655a7c20a8b843$exports))),
    "imgs/holdOnToYourStrength.png": (0, (/*@__PURE__*/$parcel$interopDefault($41bb1027ed0b2ef6$exports))),
    "imgs/hangovers.png": (0, (/*@__PURE__*/$parcel$interopDefault($eb21f7d6540d394f$exports)))
};
// STICKY NAVIGATION
const $b63be9b0371e788c$var$stickyNav = function(entries) {
    const [entry] = entries;
    if (!entry.isIntersecting) $b63be9b0371e788c$var$navContainerEl.classList.add("sticky");
    else $b63be9b0371e788c$var$navContainerEl.classList.remove("sticky");
};
const $b63be9b0371e788c$var$headerObserver = new IntersectionObserver($b63be9b0371e788c$var$stickyNav, {
    root: null,
    threshold: 0,
    rootMargin: "-1px 0px 0px 0px"
});
$b63be9b0371e788c$var$headerObserver.observe($b63be9b0371e788c$var$sentinel);
// Menu scrolling
let $b63be9b0371e788c$var$headerHeight = window.innerHeight * 0.1;
let $b63be9b0371e788c$var$lastScrollTop = 0;
window.addEventListener("scroll", function() {
    let scrollTop = window.scrollY || this.document.documentElement.scrollTop;
    if (scrollTop > $b63be9b0371e788c$var$lastScrollTop && scrollTop > $b63be9b0371e788c$var$headerHeight) // scrolling down beyond header
    $b63be9b0371e788c$var$navContainerEl.classList.add("hidden-mobile");
    else $b63be9b0371e788c$var$navContainerEl.classList.remove("hidden-mobile");
    $b63be9b0371e788c$var$lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
});
// Lazy loading images
const $b63be9b0371e788c$var$lazyLoadImages = function() {
    const lazyImages = document.querySelectorAll("img[data-src]");
    const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.1
    };
    const imageObserver = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const lazyImage = entry.target;
                // TODO: clear images that are not required
                if (lazyImage.dataset.src) {
                    // Store imported HQ images in an object, so the link does not get broken
                    // Identifying data-src for each image
                    const originalDataSrc = lazyImage.getAttribute("data-src");
                    // Attributing the right image using the original data-src
                    lazyImage.src = $b63be9b0371e788c$var$imagesObj[originalDataSrc];
                    lazyImage.removeAttribute("data-src");
                    lazyImage.classList.remove("lazy-img");
                    observer.unobserve(lazyImage);
                }
            }
        });
    }, observerOptions);
    lazyImages.forEach((lazyImage)=>imageObserver.observe(lazyImage));
};
$b63be9b0371e788c$var$lazyLoadImages();
// Function to handle the intersection
const $b63be9b0371e788c$var$handleIntersectionImg = function(entries, observer) {
    entries.forEach((entry)=>{
        entry.isIntersecting;
    });
};
// Lazy loading video
document.addEventListener("DOMContentLoaded", function() {
    const videoContainers = document.querySelectorAll(".video-container");
    function handleIntersection(entries, observer) {
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const img = entry.target.querySelector("img");
                const videoUrl = img.getAttribute("data-video");
                const video = document.createElement("video");
                video.src = videoUrl;
                video.controls = false;
                video.autoplay = true;
                video.loop = true;
                video.muted = true;
                video.playsInline = true;
                video.preload = "auto";
                video.classList.add("video");
                img.parentNode.replaceChild(video, img);
                observer.unobserve(entry.target);
            }
        });
    }
    const observer = new IntersectionObserver(handleIntersection, {
        rootMargin: "0px",
        threshold: 0.1
    });
    videoContainers.forEach((container)=>{
        observer.observe(container);
    });
});
// CAROUSEL
/*
const slider = function () {
  const slides = document.querySelectorAll('.slide');
  const btnLeft = document.querySelector('.slider__btn--left');
  const btnRight = document.querySelector('.slider__btn--right');
  let currentSlide = 0;
  const maxSlide = slides.length;
  const dotContainer = document.querySelector('.dots');

  // Functions
  const createDots = function () {
    slides.forEach(function (_, i) {
      dotContainer.insertAdjacentHTML(
        'beforeend',
        `<button class = "dots__dot dot" data-slide="${i}"></button>`
      );
    });
  };

  const activateDot = function (slide) {
    document
      .querySelectorAll('.dots__dot')
      .forEach(dot => dot.classList.remove('dots__dot--active'));

    document
      .querySelector(`.dots__dot[data-slide="${slide}"]`)
      .classList.add('dots__dot--active');
  };

  const goToSlide = function (slide) {
    slides.forEach(
      (s, i) => (s.style.transform = `translateX(${100 * (i - slide)}%)`)
    );
  };

  const nextSlide = function () {
    if (currentSlide === maxSlide - 1) {
      currentSlide = 0;
    } else {
      currentSlide++;
    }

    goToSlide(currentSlide);
    activateDot(currentSlide);
  };

  const init = function () {
    goToSlide(0);
    createDots();
    activateDot(0);
  };
  init();

  // Event handlers
  btnRight.addEventListener('click', nextSlide);

  const prevSlide = function () {
    if (currentSlide === 0) {
      currentSlide = maxSlide - 1;
    } else {
      currentSlide--;
    }
    goToSlide(currentSlide);
    activateDot(currentSlide);
  };

  btnLeft.addEventListener('click', prevSlide);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') prevSlide();
    e.key === 'ArrowRight' && nextSlide();
  });

  dotContainer.addEventListener('click', function (e) {
    if (e.target.classList.contains('dots__dot')) {
      console.log('DOT');
      const { slide } = e.target.dataset;
      console.log(e.target);
      goToSlide(slide);
      activateDot(slide);
    }
  });
};
slider();
*/ // Mobile navigation menu
$b63be9b0371e788c$var$btnNavEl.addEventListener("click", function() {
    $b63be9b0371e788c$var$navContainerEl.classList.toggle("nav-open");
});
const $b63be9b0371e788c$var$navLinksEl = document.querySelector(".nav-links");
const $b63be9b0371e788c$var$navLinkEl = document.querySelectorAll(".nav-link");
$b63be9b0371e788c$var$navLinksEl.addEventListener("click", function(e) {
    let isClickedInsideNavLinks = false;
    $b63be9b0371e788c$var$navLinkEl.forEach((link)=>{
        if (link.contains(e.target)) isClickedInsideNavLinks = true;
    });
    if (!isClickedInsideNavLinks) {
        $b63be9b0371e788c$var$navContainerEl.classList.toggle("nav-open");
        $b63be9b0371e788c$var$heroContainerEl.classList.toggle("nav-open");
    }
});
// Lore UX for the personas
const $b63be9b0371e788c$var$updateLoreBox = function(personaBox) {
    const persona = personaBox.dataset.persona;
    const imgUrl = `imgs/${persona}.png`;
    // Update mobile version
    document.querySelector(".lore-text-box-mobile .persona-lore-title").innerHTML = (0, $16e45aebe61066c2$export$2e2bcd8739ae039)[persona].title;
    document.querySelector(".lore-text-box-mobile .persona-lore-par-1").innerHTML = (0, $16e45aebe61066c2$export$2e2bcd8739ae039)[persona].par1;
    document.querySelector(".lore-text-box-mobile .persona-lore-par-2").innerHTML = (0, $16e45aebe61066c2$export$2e2bcd8739ae039)[persona].par2;
    document.querySelector(".lore-text-box-mobile .persona-lore-par-3").innerHTML = (0, $16e45aebe61066c2$export$2e2bcd8739ae039)[persona].par3;
    document.querySelector(".lore-text-box-mobile .persona-lore-par-4").innerHTML = (0, $16e45aebe61066c2$export$2e2bcd8739ae039)[persona].par4;
    // Update desktop version
    document.querySelector(".lore-text-box-desktop .persona-img").src = $b63be9b0371e788c$var$imagesObj[imgUrl];
    document.querySelector(".lore-text-box-desktop .persona-lore-title").innerHTML = (0, $16e45aebe61066c2$export$2e2bcd8739ae039)[persona].title;
    document.querySelector(".lore-text-box-desktop .persona-lore-par-1").innerHTML = (0, $16e45aebe61066c2$export$2e2bcd8739ae039)[persona].par1;
    document.querySelector(".lore-text-box-desktop .persona-lore-par-2").innerHTML = (0, $16e45aebe61066c2$export$2e2bcd8739ae039)[persona].par2;
    document.querySelector(".lore-text-box-desktop .persona-lore-par-3").innerHTML = (0, $16e45aebe61066c2$export$2e2bcd8739ae039)[persona].par3;
    document.querySelector(".lore-text-box-desktop .persona-lore-par-4").innerHTML = (0, $16e45aebe61066c2$export$2e2bcd8739ae039)[persona].par4;
};
// Active status for the first persona
const $b63be9b0371e788c$var$firstPersona = $b63be9b0371e788c$var$personaBoxElements[0];
$b63be9b0371e788c$var$firstPersona.classList.add("active");
$b63be9b0371e788c$var$updateLoreBox($b63be9b0371e788c$var$firstPersona);
// Event listener for the persona boxes
const $b63be9b0371e788c$var$handlePersonaInteraction = (e)=>{
    const personaBox = e.target.closest(".persona-box");
    if (!personaBox) return;
    // Remove the active class from all boxes
    $b63be9b0371e788c$var$personaBoxElements.forEach((persona)=>persona.classList.remove("active"));
    // Add active class to the current box
    const currentBox = e.currentTarget;
    currentBox.classList.add("active");
    // Update the lore box content
    $b63be9b0371e788c$var$updateLoreBox(personaBox);
};
$b63be9b0371e788c$var$personaBoxElements.forEach((box)=>{
    // Attach for desktop (mouse enter)
    box.addEventListener("mouseenter", $b63be9b0371e788c$var$handlePersonaInteraction);
    // Attach for tablets and touch devices (click)
    box.addEventListener("click", $b63be9b0371e788c$var$handlePersonaInteraction);
});
// Personas mobile
$b63be9b0371e788c$var$personaContainersMobile.forEach((container)=>{
    container.addEventListener("click", (e)=>{
        const personaContainer = e.target.closest(".persona-container-mobile");
        if (!personaContainer) return;
        $b63be9b0371e788c$var$loreTextContainerMobile.classList.toggle("active");
        $b63be9b0371e788c$var$updateLoreBox(personaContainer);
    });
});
$b63be9b0371e788c$var$loreTextContainerMobile.addEventListener("click", (e)=>{
    $b63be9b0371e788c$var$loreTextContainerMobile.classList.toggle("active");
});
document.querySelector(".close-overlay").addEventListener("click", (e)=>{
    e.stopPropagation();
    $b63be9b0371e788c$var$loreTextContainerMobile.classList.remove("active");
});
function $b63be9b0371e788c$var$toggleSectionsBasedOnScreenSize() {
    const mobileSection = document.querySelector(".personas-section-mobile");
    const desktopSection = document.querySelector(".personas-section-desktop");
    if (window.innerWidth < 768) {
        // Adjust the breakpoint as needed
        mobileSection.classList.remove("hidden");
        desktopSection.classList.add("hidden");
    } else {
        mobileSection.classList.add("hidden");
        desktopSection.classList.remove("hidden");
    }
}
// Check when the page loads
document.addEventListener("DOMContentLoaded", $b63be9b0371e788c$var$toggleSectionsBasedOnScreenSize);
// Check when the window is resized
window.addEventListener("resize", $b63be9b0371e788c$var$toggleSectionsBasedOnScreenSize);


//# sourceMappingURL=index.c601e02f.js.map
